import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	show: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.common.legend.toggle-button.show',
		defaultMessage: 'Show legend',
		description: 'Text of the show legend button',
	},
	hide: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.common.legend.toggle-button.hide',
		defaultMessage: 'Hide legend',
		description: 'Text of the hide legend button',
	},
});
